import { omit } from 'lodash'

import Field from '@/components/Form/Field'
import cn from '@/utilities/cn'

import './index.scss'

/**
 * @example
 *  <FormattedHeader
 *   label={<FormattedMessage {...messages.someLabel} />}
 *   name="title"
 *   required
 *   tooltip={<FormattedMessage {...messages.someToolTip} />}
 />
 */

const FormattedHeader = (props: any) => {
  const fieldProps = omit(props, ['onChange', 'className'])
  return <Field {...fieldProps} className={cn('field__spacing')} />
}

FormattedHeader.displayName = 'FormattedHeader'

export default FormattedHeader
